// extracted by mini-css-extract-plugin
module.exports = {"container":"Waiting_container__psswq","header":"Waiting_header__2DmaB","message":"Waiting_message__2p7ki"};